import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing a filter view for withdrawal requests.
 * @extends JetView
 */
export default class FilterWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the filter with a richselect for acceptance type
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown selection component
                    name: 'AcceptanceType', // Name of the field
                    localId: 'bonusStates:combo', // Local ID for referencing
                    label: _("<span class='icon-state'></span> Estado"), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: '', // Default value
                    options: [
                        // Options for the dropdown
                        { id: '', value: _('Todos') }, // All option
                        { id: 'A', value: _('Activo') }, // Active option
                        { id: 'I', value: _('Inactivo') }, // Inactive option
                    ],
                },
            ],
        };

        // Right section of the filter (currently empty)
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Additional right section (currently empty)
        const right = {
            margin: 5,
            rows: [],
        };

        // Upper section combining left and a spacer
        const upper_section = {
            cols: [
                center_left, // Left section
                { gravity: 1, minWidth: 10 }, // Spacer
            ],
        };

        // Button section with clear and consult buttons
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true, // Auto width adjustment
                    click: () => {
                        // Click event handler
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form', // Type indicating it's a form button
                    autowidth: true, // Auto width adjustment
                    click: () => {
                        // Click event handler
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('bankAccountReport:filter', [
                            // Trigger filter event
                            filterdata,
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Rows containing upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
